import { notification } from "antd";

import { GET_OFFER_RESPONSES, GET_OFFER_RESPONSE_BY_ID } from "./types";
import { SPremiumAuthorizedApiService } from "../../../services/apiServices";

import { downloadBlobFile } from "../../../helpers/downloadBlobFile";
import { mapDataRows } from "../../../helpers/mapDataRows";
import { NavigationPath } from "../../../helpers/constants";

export const getOfferResponses = () => async (dispatch) => {
  SPremiumAuthorizedApiService.get("/offer-response")
    .then((res) => {
      const { status, data } = res;
      if (status !== 200) {
        notification.error({
          message: "Something went wrong, can not get offer responses",
        });
        return;
      }

      const offerResponses = mapDataRows(data.rows);

      dispatch({
        type: GET_OFFER_RESPONSES,
        payload: offerResponses,
      });
    })
    .catch((err) => {
      notification.error({
        message: "Something went wrong",
      });
    });
};

export const deleteOfferResponse = (ids) => async (dispatch) => {
  SPremiumAuthorizedApiService.delete(`/offer-request/`, {
    data: { ids },
  })
    .then((res) => {
      const { status } = res;

      if (status !== 204) {
        notification.error({
          message: "Something went wrong",
        });
        return;
      }
      notification.success({
        message:
          ids.length === 1 ? "Offer request deleted" : "Offer requests deleted",
      });
      getOfferResponses()(dispatch);
    })
    .catch((err) => {
      notification.error({
        message: "Something went wrong",
      });
    });
};

export const deleteSingleOfferResponse = (ids) => async (dispatch) => {
  SPremiumAuthorizedApiService.delete(`/offer-response/`, {
    data: { ids },
  })
    .then((res) => {
      const { status } = res;

      if (status !== 204) {
        notification.error({
          message: "Something went wrong",
        });
        return;
      }
      notification.success({
        message:
          ids.length === 1
            ? "Offer response deleted"
            : "Offer responses deleted",
      });
      getOfferResponses()(dispatch);
    })
    .catch((err) => {
      notification.error({
        message: "Something went wrong",
      });
    });
};

export const exportPdf = (offerRequestId) => async (dispatch) => {
  SPremiumAuthorizedApiService.get(
    `/offer-response/${offerRequestId}/export-all`,
    {
      responseType: "blob",
    }
  )
    .then((res) => {
      const { status } = res;

      if (status !== 200) {
        notification.error({
          message: "Something went wrong, can not export pdf file",
        });
        return;
      }

      const blob = new Blob([res.data], {
        type: res.headers["content-type"],
      });
      downloadBlobFile(blob, "sve_ponude.pdf");
    })
    .catch((err) => {
      notification.error({
        message: "Something went wrong",
      });
    });
};

export const getOfferResponseById = (id) => async (dispatch) => {
  SPremiumAuthorizedApiService.get(`/offer-response/${id}`)
    .then((res) => {
      const { status, data } = res;
      if (status !== 200) {
        notification.error({
          message: "Something went wrong, can not get offer response",
        });
        return;
      }

      dispatch({
        type: GET_OFFER_RESPONSE_BY_ID,
        payload: data,
      });
    })
    .catch((err) => {
      notification.error({
        message: "Something went wrong",
      });
    });
};

export const updateOfferResponse =
  (id, responseDetails, navigate) => async (dispatch) => {
    SPremiumAuthorizedApiService.put(`/offer-response/${id}`, responseDetails)
      .then((res) => {
        const { status } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong, can not complete offer response",
          });
          return;
        }
        notification.success({
          message: "Complete success!",
        });
        navigate(NavigationPath.OFFER_RESPONSES_ROUTE);
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong",
        });
      });
  };

export const downloadFile = (id, filename) => async (dispatch) => {
  SPremiumAuthorizedApiService.get(`offer-response/${id}/file-download`, {
    responseType: "blob",
  })
    .then((res) => {
      const blob = new Blob([res.data]);
      downloadBlobFile(blob, filename);
    })
    .catch((err) => {
      notification.error({
        message: "Download error!",
      });
    });
};
